const KEY = "ss-study-progress";

export function markLessonStudiedToday() {
  localStorage.setItem(
    KEY,
    new Date().toISOString().slice(0, 10)
  );
}

export function isLessonStudiedToday() {
  return (
    localStorage.getItem(KEY) ===
    new Date().toISOString().slice(0, 10)
  );
}